import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  container: (isActive: boolean, top = 0, isStatic = false) => ({
    position: isStatic ? 'static' : 'fixed',
    width: '100%',
    height: !isActive && isStatic ? 0 : 'auto',
    transition: `transform ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    transform: isActive ? 'translateY(0)' : 'translateY(-100%)',
    zIndex: isStatic ? theme.zIndex.documentUp : theme.zIndex.barUp,
    top,
    left: 0,
    overflow: 'hidden',
    ...reusables.mainTransition('height', theme.transitions.animation.atomCurve, theme.transitions.time.normal)
  }),
  popup: (isActive: boolean) => ({
    position: 'relative',
    display: 'flex',
    flexFlow: ['column nowrap', 'column nowrap', 'row nowrap'],
    justifyContent: ['uset', 'uset', 'space-between'],
    width: '100%',
    height: 'auto',
    transition: `transform ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    transform: isActive ? 'translateY(0)' : 'translateY(-100%)',
    backgroundColor: theme.rawColors.darkGrey700,
    p: ['24px 16px 24px 16px', '24px 16px 24px 16px', '24px 24px 24px 24px', '24px 40px 24px 40px'],
    borderBottom: `1px solid ${theme.rawColors.darkGrey600}`
  }),
  message: {
    maxWidth: 420,
    color: theme.rawColors.neutralWhite,
    fontSize: theme.fontSizes.caption,
    p: ['0 40px 16px 0', '0 40px 16px 0', '0 40px 16px 0', 0]
  },
  buttons: {
    display: 'flex',
    flexFlow: ['row wrap', 'row wrap', 'column nowrap'],
    justifyContent: ['space-between', 'space-between', 'start'],
    pr: [40, 40, 40],
    a: {
      width: 'auto',
      height: 36,
      mb: ['unset', 'unset', '8px'],
      mr: ['8px', '8px', 'unset'],
      '&:first-of-type': {
        mb: ['24px', '8px']
      }
    },
    button: {
      '&:hover': {
        span: {
          color: theme.rawColors.neutralWhite
        },
        backgroundColor: 'transparent !important;'
      }
    },
    close: {
      position: 'absolute',
      top: 24,
      right: [16, 16, 24, 40]
    }
  }
};